import { useMemo } from "react";
import { supabase } from "../services/supabase/Supabase";
import { createApiClient } from "./createApiClient";
import { useRegion } from "./regions";

const useApiClient = (requireAuthentication: boolean = true) => {
  const { region } = useRegion();
  return useMemo(
    () =>
      createApiClient({
        baseUrl: region.baseUrl,
        supabase,
        requireAuthentication,
      }),
    [requireAuthentication, region.baseUrl],
  );
};

export default useApiClient;
